export default "__VITE_ASSET__DkdzufMi__"